import {AsyncInlineError, streamify, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

import {UserErrorsFactory} from '../Errors/factory.js'
import UserRepositoriesFactory from '../Repositories/factory.js'
import UserServicesFactory from '../Services/factory.js'

@streamify('execute')
export class UnblockUserUseCase extends UseCase {
  #config
  #repository
  #currentUserService
  #userNotLoggedInUserError

  constructor({config, repository, currentUserService, userNotLoggedInUserError}) {
    super()
    this.#config = config
    this.#repository = repository
    this.#currentUserService = currentUserService
    this.#userNotLoggedInUserError = userNotLoggedInUserError
  }

  static create({config}) {
    return new UnblockUserUseCase({
      config,
      repository: UserRepositoriesFactory.httpUserRepository({config}),
      currentUserService: UserServicesFactory.getCurrentUserService({config}),
      userNotLoggedInUserError: UserErrorsFactory.userNotLoggedInUserError
    })
  }

  @tracer({metric: 'UnblockUserUseCase#execute'})
  @AsyncInlineError()
  async execute({userToUnblockId}) {
    const userEntity = await this.#currentUserService.execute()

    if (!userEntity)
      return Promise.reject(
        this.#userNotLoggedInUserError({
          message: 'To unblock a user, the user must be logged in'
        }).toJSON()
      )
    const [error] = await this.#repository.unblockUser({userEntity, userToUnblockId})

    if (error) return Promise.reject(error)
    return Promise.resolve(true)
  }
}

export const factory = UnblockUserUseCase.create
